import React from 'react'

const WAOR2021 = () => {
    return (
        <div>
            WA-OR2021 - COMING SOON
        </div>
    )
}

export default WAOR2021